module.exports = __webpack_public_path__ + "static/media/chuck_dirk.a5bf0a9c.png";